let aboutScrollGradientCleanup;

function initAboutScrollGradient() {
  if (aboutScrollGradientCleanup) aboutScrollGradientCleanup();

  const aboutSection = document.querySelector("[data-about-scroll-gradient]");
  if (!aboutSection) return;

  const gradient = aboutSection.querySelector(".about-scroll-gradient");
  const sectionWrapper = aboutSection;
  const sectionSiblings = Array.from(sectionWrapper.parentElement.children);
  const aboutPageSections = sectionSiblings.slice(sectionSiblings.indexOf(sectionWrapper));
  const triggerSection = aboutPageSections[0];
  const gradientEndSection = aboutPageSections[aboutPageSections.length - 1];
  if (!gradient || !triggerSection || !gradientEndSection) return;

  let frame = null;

  function clamp(value) {
    return Math.min(Math.max(value, 0), 1);
  }

  function updateGradient() {
    frame = null;

    const scrollY = window.pageYOffset || document.documentElement.scrollTop;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const triggerRect = triggerSection.getBoundingClientRect();
    const gradientEndRect = gradientEndSection.getBoundingClientRect();
    const aboutRect = aboutSection.getBoundingClientRect();
    const triggerTop = triggerRect.top + scrollY + 20;
    const aboutBottom = aboutRect.bottom + scrollY;
    const gradientEndBottom = gradientEndRect.bottom + scrollY;
    const fadeStart = triggerTop;
    const fadeEnd = Math.max(triggerTop + viewportHeight, gradientEndBottom - viewportHeight);
    const progress = fadeEnd === fadeStart ? 1 : clamp((scrollY - fadeStart) / (fadeEnd - fadeStart));
    const extension = Math.max(0, gradientEndBottom - aboutBottom);

    const opacity = (1 - progress).toFixed(3);

    gradient.style.opacity = opacity;
    document.documentElement.style.setProperty("--about-scroll-gradient-opacity", opacity);
    gradient.style.setProperty("--about-scroll-gradient-bottom", `-${extension}px`);
    gradient.classList.toggle("is-active", extension > 0);
  }

  function requestUpdate() {
    if (frame !== null) return;
    frame = window.requestAnimationFrame(updateGradient);
  }

  window.addEventListener("scroll", requestUpdate, { passive: true });
  window.addEventListener("resize", requestUpdate);
  requestUpdate();

  aboutScrollGradientCleanup = function () {
    window.removeEventListener("scroll", requestUpdate);
    window.removeEventListener("resize", requestUpdate);
    if (frame !== null) window.cancelAnimationFrame(frame);
    document.documentElement.style.removeProperty("--about-scroll-gradient-opacity");
    aboutScrollGradientCleanup = null;
  };
}

initAboutScrollGradient();
document.addEventListener("shopify:section:load", initAboutScrollGradient);
